const minimalSearchTime = 1500

export const minimalTime = (): Promise<void> =>
  new Promise((resolve) => {
    setTimeout(() => {
      resolve()
    }, minimalSearchTime)
  })
